import data from "../../.sourceflow/statistics.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getStatistics = (locale = "en") => {
  return new BaseCollection(data, locale).getItems();
};
